<template>
  <div class="goods-wrapper" v-show="goodsList.length">
    <div class="title" v-show="title">{{ title }}</div>
    <list
      :finished="finished"
      :immediate-check="false"
      @load="onLoad"
      finished-text="没有更多了"
      v-model="loading"
    >
      <goods-list :sku-list="goodsList"></goods-list>
    </list>
  </div>
</template>
<script>
import api from '../utils/api'
import { List } from 'vant'
import goodsList from './ProductDoubleEach'
import { mapState } from 'vuex'
let flag = false
export default {
  components: {
    List,
    goodsList
  },
  props: {
    columnConfig: {
      type: Object
    },
    title: {
      type: [String, Boolean],
      defaule: false
    }
  },
  data () {
    return {
      goodsList: [],
      pageNum: 1,
      loading: false,
      finished: false
    }
  },
  computed: {
    ...mapState('store', ['cityCode'])
  },
  watch: {
    cityCode () {
      this.pageNum = 1
      goodsList = []
      this.finished = false
    }
  },
  created () {
    if (this.columnConfig && this.columnConfig.sku_list) {
      this.goodsList = this.columnConfig.sku_list
    } else {
      this.getGoodsList()
    }
  },
  methods: {
    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getGoodsList(++this.pageNum).then(() => {
          setTimeout(() => {
            this.loading = false
            flag = false
          }, 500)
        })
      }, 300)
    },
    async getGoodsList (pageNum) {
      const res = await api.getProductList({ id: this.columnConfig.column, pageNum: pageNum || 1 })
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          // console.log(this.goodsList)
          this.goodsList = [...this.goodsList, ...data]
        } else if (code === 9006) {
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  padding: 0.3rem 0 0.1rem;
  font-size: @fz34;
  color: @base;
  text-align: center;
  font-weight: 500;
}
.goods-wrapper {
  padding: 0 0.2rem;
  // background-color: #eee;
}
</style>
